// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Hjce","toggle":"styles_toggle__1k4Kq","preview":"styles_preview__198OE"};